import Navbar from '../components/Navbar';
import EmployeeTable from '../components/EmployeeTable';
import '../styles/styles.css'

const EmployeePage = () => {
    return (
        <div>
             <Navbar />
             <EmployeeTable/>
        </div>
    );
};

export default EmployeePage;